<div [formGroup]="form">

    <app-ativacao-section-card
        [control]="ativoControl"
        titulo="Monofásica Retenção"
        [exibirTituloNoAlerta]="false"
        descricaoAtivo="Modalidade de retenção ativa. As alíquotas por unidade abaixo serão aplicadas na retenção monofásica."
        descricaoInativo="Modalidade de retenção inativa. Ative para informar as alíquotas por unidade retidas de IBS e CBS."
        emptyStateTitulo="Monofásica Retenção desativada"
        emptyStateDescricao="Ative a modalidade de retenção acima para informar as alíquotas por unidade de IBS e CBS.">
    </app-ativacao-section-card>

    @if (ativoControl.value) {
    <div class="section-container">
        <div class="section-title">
            <mat-icon class="material-symbols-outlined">savings</mat-icon>
            <span>Monofásica Retenção</span>
            <div class="section-title-actions ms-auto">
                <button mat-button type="button" class="btn-section" [matBadge]="personalizadasCount" [matBadgeHidden]="personalizadasCount === 0" (click)="abrirEditorFormulas()">
                    <mat-icon class="material-symbols-outlined">settings</mat-icon>
                    Personalizar fórmulas
                </button>
            </div>
        </div>

        <div class="row g-3">
            <div class="col-12 col-md-4">
                <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                    <mat-label>Alíquota por unidade IBS (retenção)</mat-label>
                    <input matInput type="text" inputmode="numeric" [currencyMask]="currencyMask" formControlName="adRemIbsReten">
                    <mat-error>{{ form.get('adRemIbsReten')?.hasError('min') ? 'O ad rem do IBS do monofásico com retenção não pode ser negativo.' : 'Informe o ad rem do IBS e da CBS do monofásico com retenção.' }}</mat-error>
                </mat-form-field>
            </div>
            <div class="col-12 col-md-4">
                <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                    <mat-label>Alíquota por unidade CBS (retenção)</mat-label>
                    <input matInput type="text" inputmode="numeric" [currencyMask]="currencyMask" formControlName="adRemCbsReten">
                    <mat-error>{{ form.get('adRemCbsReten')?.hasError('min') ? 'O ad rem da CBS do monofásico com retenção não pode ser negativo.' : 'Informe o ad rem do IBS e da CBS do monofásico com retenção.' }}</mat-error>
                </mat-form-field>
            </div>
        </div>
    </div>
    }
</div>
